/**
 * Tree Navigation Item Expand enum
 *
 * @package lib-components
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export enum TREE_NAVIGATION_ITEM_EXPAND {
	DEFAULT = "default",
	EXPANDED = "expanded",
	COLLAPSED = "collapsed"
}

export type TREE_NAVIGATION_ITEM_EXPAND_string = keyof typeof TREE_NAVIGATION_ITEM_EXPAND;
